export default __webpack_public_path__ + "static/media/Tutorial-Step-2.1.81ff3e28.jpg";